var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overlay',{attrs:{"absolute":true,"opacity":0.5,"value":_vm.show}})}
var staticRenderFns = []

export { render, staticRenderFns }